import { publishGa4Events } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import { pnm } from '@porterin/feature/src/containers/fare-estimate-v1/domain/store/CategoryAnalyticsStore';
import { PAYMENT_SUCCESS_EVENT } from '@porterin/feature/src/containers/home/domain/store/HomeStoreEn';
import NextImageV2 from '@porterin/feature/src/ui/components/NextImageV2';
import React, { useEffect } from 'react';

import {
  orderDetailsIconAlt,
  orderDetailsImgUrl,
  paymentSuccessHeader,
  paymentSuccessIconAlt,
  successImgUrl,
  weAreBetterOnApp,
} from '../store/PaymentSuccessStore';
import styles from '../styles/PaymentSuccess.module.scss';

import PaymentSuccessMobFooterCmp from './PaymentSuccessMobFooterCmp';

function PaymentSuccessCmp(): React.ReactElement {
  useEffect(() => {
    publishGa4Events(pnm, PAYMENT_SUCCESS_EVENT);
  }, []);

  return (
    <div className={styles['payment-success-container']}>
      <div className={styles['payment-success-main']}>
        <NextImageV2
          src={successImgUrl}
          width={80}
          height={80}
          alt={paymentSuccessIconAlt}
        />
        <h3 className={styles['payment-success-heading']}>
          {paymentSuccessHeader}
        </h3>
      </div>
      <div className={styles['heading-container']}>
        <h3 className={styles['heading']}>{weAreBetterOnApp}</h3>
      </div>
      <div className={styles['app-image']}>
        <NextImageV2
          src={orderDetailsImgUrl}
          width={300}
          height={319}
          alt={orderDetailsIconAlt}
        />
      </div>
      <PaymentSuccessMobFooterCmp />
    </div>
  );
}

export default PaymentSuccessCmp;
